import tight1664logo from './assets/logo/tight1664logo.png';
import profileIcon from './assets/icon/profileIcon.png';
import './Header.scss';
import './index.scss';
import supabase from './helper/supabaseClient';
import { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useUserProfile } from './helper/UserProfile';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [member, setMember] = useState("");
  const { profile } = useUserProfile();

  const toggleMenu = () => setMenuOpen(prev => !prev);

  const navigate = useNavigate();

  const signOut = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
    navigate("/");
  };

  useEffect(() => {
      if (profile && profile.revalidation_membership !== undefined) {
          setMember(profile.revalidation_membership);
      }
  }, [profile]);

  return (
    <div className="Header">
      <header className="App-header">
          <Link to="/dashboard"><img src={tight1664logo} className="App-logo" alt="logo" /></Link>
          <div className="Profile-container" style={{ position: 'relative' }}>
          <img
            src={profileIcon}
            className="Profile-icon"
            alt="profile"
            onClick={toggleMenu}
            style={{ cursor: 'pointer' }}
          />
           {menuOpen && (
            <div className="Dropdown-menu">
              <ul style={{ listStyle: 'none', margin: 0, padding: '10px' }}>
                <li><Link to="/dashboard/profile" onClick={toggleMenu}>PROFILE</Link></li>

                <li><Link to="/dashboard/competencies" onClick={toggleMenu}>COMPETENCIES</Link></li>

                <li>{member === false && (<FontAwesomeIcon icon={faLock} style={{color: "#1a1a1a"}} className="icon"/>)}<Link to="/dashboard/details" onClick={toggleMenu}>REVALIDATION DETAILS</Link></li>
                
              <button className="signoutButton" onClick={signOut}>SIGN OUT</button>
              </ul>
            </div>
          )}
        </div>
      </header>
    </div>
  );
}

export default Header;